import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, FieldText, IconButton, Text, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import ColorField from 'components/shared/util/ColorField';
import { stringToHexColor } from 'components/shared/util/color';
import { withTags } from 'hocs';
import { useNotifications } from 'hooks/useNotifications';
import styles from './addTag.module.scss';
function AddTagImpl({ onAddTag, onClose, tagName, tags }) {
    const notify = useNotifications();
    const [isCreating, setIsCreating] = useState(false);
    const [{ color, name }, setState] = useState({
        color: stringToHexColor(tagName),
        name: tagName,
    });
    const handleNameChange = useCallback((event) => {
        if (event === null || event === void 0 ? void 0 : event.target.value) {
            setState((state) => (Object.assign(Object.assign({}, state), { name: event === null || event === void 0 ? void 0 : event.target.value })));
        }
    }, []);
    const handleColorChange = useCallback((color) => {
        setState((state) => (Object.assign(Object.assign({}, state), { color })));
    }, []);
    const handleAddTag = useCallback(() => {
        setIsCreating(true);
        tags
            .create({ color, name })
            .then(({ data: tag }) => {
            onAddTag(tag);
            notify({
                title: 'Tag created',
                text: `"${name}" tag has been created`,
                icon: 'i-done',
                className: 'success',
                time: 5000,
            });
            onClose();
        })
            .catch(() => {
            notify({
                title: 'An error occurred',
                text: `An error occurred when trying to create the "${name}" tag`,
                icon: 'i-exclamation',
                className: 'danger',
            });
            setIsCreating(false);
        });
    }, [color, name, notify, onAddTag, onClose, tags]);
    return (_jsxs(Box, Object.assign({ className: styles.root }, { children: [_jsxs("div", Object.assign({ className: styles.head }, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: "Add new tag" })), _jsx(IconButton, { disabled: isCreating, variant: "tertiary", icon: "close", onClick: onClose })] })), _jsx(FieldText, { label: "Name", input: {
                    name: 'tagName',
                    onChange: handleNameChange,
                    value: name,
                }, maxLength: 255, placeholder: "Name...", required: true, type: "text" }), _jsx(ColorField, { label: "Tag color", input: {
                    name: 'tagColor',
                    onChange: handleColorChange,
                    value: color,
                }, showSpinner: false }), _jsx(Button, Object.assign({ className: styles.button, isLoading: isCreating, onClick: handleAddTag }, { children: "Create and add" }))] })));
}
export const AddTag = withTags(AddTagImpl);
